export function loadOTErrcode(boiler_type, ba_protocol, ot_state) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'OT_ERRCODES__LOAD', boiler_type, ot_state });
        try {
            const json = await api.opentherm_error_description_v2(boiler_type, ba_protocol, ot_state);
            dispatch({
                type: 'OT_ERRCODES__READY',
                boiler_type,
                ot_state,
                ok: true,
                result: json,
            });
        }
        catch (error) {
            dispatch({
                type: 'OT_ERRCODES__READY',
                boiler_type,
                ot_state,
                ok: false,
                result: null,
            });
        }
    };
}
